import { calcEffectiveBS } from "@/constants/game.constants"
import {
  BattleCardBreakdown,
  BattlePlayerInfo,
  BattleResultPayload,
  BattleSideReveal,
  BattleStartedPayload,
} from "@/types/battle"
import { parseDustGrant } from "@/utils/shardsNormalize"
import {
  mergeCardShardSlots,
  normalizeBattleCardView,
} from "@/utils/battleCards"
import { normalizeBattlePlayerInfo } from "@/utils/challengePayload"
import { enrichBattlePlayer } from "@/utils/battlePlayerEnrich"

function normalizeCombat(combat: BattleCardBreakdown): BattleCardBreakdown {
  return {
    ...combat,
    effectiveBS: calcEffectiveBS(combat),
  }
}

function normalizeSide(
  side: BattleSideReveal,
  lobbyPlayer?: BattlePlayerInfo | null
): BattleSideReveal {
  const raw = side as BattleSideReveal & Record<string, unknown>
  const card = normalizeBattleCardView(side.card) ?? side.card
  const normalizedPlayer =
    normalizeBattlePlayerInfo(side.player) ?? side.player
  const player = lobbyPlayer
    ? enrichBattlePlayer(normalizedPlayer, lobbyPlayer)
    : normalizedPlayer
  return {
    ...side,
    player,
    card,
    combat: normalizeCombat(side.combat),
    dustGrant: parseDustGrant(raw) ?? side.dustGrant ?? null,
  }
}

export function mapBattleResult(
  started: BattleStartedPayload,
  result: BattleResultPayload
): { yourSide: BattleSideReveal; opponentSide: BattleSideReveal } {
  const isYouA = started.you.userId === result.playerA.player.userId
  const yourRaw = isYouA ? result.playerA : result.playerB
  const opponentRaw = isYouA ? result.playerB : result.playerA
  const lobbyYou = normalizeBattlePlayerInfo(started.you) ?? started.you
  const lobbyOpponent =
    normalizeBattlePlayerInfo(started.opponent) ?? started.opponent
  const yourSide = normalizeSide(yourRaw, lobbyYou)
  const opponentSide = normalizeSide(opponentRaw, lobbyOpponent)
  const fromHand = started.yourCards.find((c) => c.id === yourSide.card.id)
  return {
    yourSide: {
      ...yourSide,
      card: mergeCardShardSlots(yourSide.card, fromHand),
    },
    opponentSide,
  }
}
